import classNames from 'classnames';
import React, { useCallback, useState } from 'react';
import { useRouteChange } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import Modal from './modal';
const prefixCls = createPrefixCls('action-sheet');
export const ActionSheet = ({ title, options, cancelText = '取消', onSelect, onCancel, onClose, onUnMount }) => {
    const [visible, setVisible] = useState(true);
    useRouteChange(() => {
        setVisible(false);
    });
    const handleSelect = useCallback((option) => {
        return () => {
            if (!option.disabled) {
                setVisible(false);
                onSelect && onSelect(option.value);
            }
        };
    }, [onSelect]);
    const handleCancel = useCallback(() => {
        setVisible(false);
        onCancel && onCancel();
    }, [onCancel]);
    const handleClose = useCallback(() => {
        setVisible(false);
        onClose && onClose();
        onUnMount && onUnMount();
    }, [onClose, onUnMount]);
    return (React.createElement(Modal, { className: prefixCls('body'), visible: visible, onClose: handleClose },
        React.createElement("div", { className: prefixCls() },
            React.createElement("div", { className: prefixCls('panel') },
                title && React.createElement("div", { className: prefixCls('title') }, title),
                React.createElement("div", { className: prefixCls('options') }, options.map((option) => {
                    return (React.createElement("div", { key: option.value, className: classNames(prefixCls('option'), { [prefixCls('option-disabled')]: option.disabled }, {
                            [prefixCls(`option-type-${option.type}`)]: option.type
                        }), onClick: handleSelect(option) }, option.text));
                }))),
            React.createElement("div", { className: prefixCls('cancel'), onClick: handleCancel }, cancelText))));
};
export default ActionSheet;
